function TailWind() {
    return (<div>
        I've recently updated my website to use Tailwind styling instead of pure CSS. I also added this update page to replace the under-used CTF page.
    </div>);
}

export default TailWind;